// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const deleteFolder = (id, contextConfiguration) => axios.delete(
	`/bookmark_folders/${id}`,
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default deleteFolder;
